

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.com/docs/use-static-query/
 */
import React from "react"
import { withPrefix, StaticQuery, graphql } from "gatsby"

import Img from "gatsby-image"



const Image = (props) => {
  return (
    <StaticQuery
      query={graphql`
    query {
      images: allFile {
        edges {
          node {
            publicURL
            relativePath
            name
            childImageSharp {
              fluid(maxWidth: 1280) {
                ...GatsbyImageSharpFluid
              }
              resize {
                aspectRatio
              }
            }
            base
            internal {
              type
              mediaType
            }
          }
        }
      }
      site {
        pathPrefix
      }
    }
  `}
      render={(data) => {
        const prefixedUrl = ''
        var image = data.images.edges.find(n => {
          return n.node.relativePath.includes(props.src);
        });
        if (image !== undefined) {
          if (image.node.internal.mediaType == "image/svg+xml") {
            return (
              <img {...props} src={image.node.publicURL} />
            );
          } else {
            if (!image) { return null; }
            image.node.childImageSharp.fluid.srcSet = image.node.childImageSharp.fluid.srcSet.replace(/(\/static)/g, prefixedUrl + '$1')
            return (
              <Img fluid={image.node.childImageSharp.fluid} alt={props.alt} data-aspect-ratio={image.node.childImageSharp.aspectRatio} />
            );
          }
        } else {
          console.warn(props.src + ' is not defined',)
        }
      }}
    />
  )
}

export default Image
